import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { getMerchCardsToShow, getMerchCardsToShowPaid, getMerchCardsToShowProEnterpriseOnly, getStarterCustomerPlatformUpsellCardIndex } from '../../constants/merchCards/MerchCardsToShow';
import { SCREENS } from '../../constants/tracking/Screens';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import { useSSM0009Experiment } from '../../utils/experiments/ssm0009';
import { HighlightedFreeCard } from './HighlightedFreeCard';
import HighlightedMerchCard from './HighlightedMerchCard';
import { MerchCardShadowColumns, ShadowColumn } from './MerchCardSharedComponents';
import StarterCustomerPlatformUpsellCard from './StarterCustomerPlatformUpsellCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const {
    isSSM0009Variant,
    isSSM0009HideStarter
  } = useSSM0009Experiment();
  const getProductLevels = () => {
    if (isSSM0009Variant) {
      if (isSSM0009HideStarter) {
        return getMerchCardsToShowProEnterpriseOnly();
      } else {
        return getMerchCardsToShowPaid();
      }
    }
    return getMerchCardsToShow({
      tab: selectedTab
    });
  };
  const productLevels = getProductLevels();
  const isAppReady = useGlobalLoading();
  const ownedProducts = useAppSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const isTBEligible = useAppSelector(state => {
    if (!isAppReady) return false;
    return hasAnyTBSkuInProductDataSelector(state);
  });
  const isFreePortal = !selectedTab && (ownedProducts === null || ownedProducts === void 0 ? void 0 : ownedProducts.length) <= 0;
  const isPublic = !!selectedTab;
  const isEnterpriseTab = selectedTab === 'enterprise';
  const showStarterCustomerPlatformUpsellCard = (isFreePortal || isPublic) && isTBEligible && !isEnterpriseTab && !isSSM0009HideStarter; // ssm0009 experiment variant query param

  const starterCustomerPlatformUpsellCardIndex = getStarterCustomerPlatformUpsellCardIndex({
    isPublic,
    isSSM0009Variant
  });

  // if showing StarterCustomerPlatformUpsellCard, add 1 to the column count so the grid will have enough columns
  const columnCount = showStarterCustomerPlatformUpsellCard ? productLevels.length + 1 : productLevels.length;
  const merchCardComponents = productLevels.map((productLevel, index) => {
    let columnStart = index + 1;

    // Push merch cards to the right 1 place to make room for StarterCustomerPlatformUpsellCard
    if (index >= starterCustomerPlatformUpsellCardIndex) {
      const offset = showStarterCustomerPlatformUpsellCard ? 2 : 1;
      columnStart = index + offset;
    }
    const gridItemProps = {
      gridColumnStart: columnStart,
      paddingInline: '700'
    };
    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(HighlightedFreeCard, {
        productLine: productLine,
        columnStart: columnStart
      }, `${productLine}-${productLevel}`);
    }
    return /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      gridItemProps: gridItemProps,
      selectedTab: selectedTab
    }, `${productLine}-${productLevel}`);
  });
  const shadowColumns = new Array(columnCount).fill('').map((value, index) => {
    // for the second column (StarterCustomerPlatformUpsellCard), use a gray background color
    if (showStarterCustomerPlatformUpsellCard && index === starterCustomerPlatformUpsellCardIndex) return /*#__PURE__*/_jsx(ShadowColumn, {
      backgroundColor: "fill-field-default"
    }, index);
    return /*#__PURE__*/_jsx(ShadowColumn, {}, index);
  });
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsxs(MerchCardShadowColumns, {
      columns: columnCount,
      shadowColumnsComponent: shadowColumns,
      children: [merchCardComponents, showStarterCustomerPlatformUpsellCard ? /*#__PURE__*/_jsx(StarterCustomerPlatformUpsellCard, {
        productLine: productLine,
        gridItemProps: {
          paddingInline: '700',
          gridColumnStart: starterCustomerPlatformUpsellCardIndex + 1
        },
        screen: SCREENS[productLine],
        selectedTab: selectedTab
      }) : null]
    })
  });
};
export default HubTierInfo;